(() => {
  const routine = document.querySelector('[data-acy-routine]');
  if (!routine || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const steps = [...routine.querySelectorAll('[data-acy-routine-step]')];
  const flow = routine.querySelector('[data-acy-routine-flow]');
  const tracker = routine.querySelector('.acy-v13-routine__tracker');
  if (!steps.length || !tracker || !flow) return;

  let current = -1;
  const stops = [
    { left: 23, top: 76 },
    { left: 77, top: 76 },
    { left: 77, top: 24 },
    { left: 23, top: 24 },
  ];
  const activate = (index) => {
    if (index === current) return;
    current = index;
    steps.forEach((step, index) => {
      const active = index === current;
      step.classList.toggle('is-active', active);
    });
    const stop = stops[Math.min(current, stops.length - 1)];
    tracker.style.left = `${stop.left}%`;
    tracker.style.top = `${stop.top}%`;
    routine.style.setProperty('--routine-index', current);
  };

  let ticking = false;

  const render = () => {
    ticking = false;
    const rect = flow.getBoundingClientRect();
    const distance = Math.max(1, flow.offsetHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, -rect.top / distance));
    activate(Math.min(steps.length - 1, Math.floor(progress * steps.length)));
  };

  const requestRender = () => { if (!ticking) { ticking = true; window.requestAnimationFrame(render); } };
  // Das Theme scrollt je nach Layout in .page-wrapper statt im Fenster; ein
  // Listener am window feuert dann nie und die Routine bliebe eingefroren.
  // Scroll-Events steigen nicht auf, laufen aber durch die Capture-Phase von
  // document — dort abgefangen, greift es in beiden Fällen. Die Berechnung
  // selbst nutzt getBoundingClientRect und ist vom Scroll-Container unabhängig.
  document.addEventListener('scroll', requestRender, { passive: true, capture: true });
  window.addEventListener('resize', requestRender, { passive: true });
  requestRender();
})();
